<template>
  <div class="container tem024">
    <NoticeBox class="-error _mb-sm-40 _mb-md-60">
      <NoticeHeader>
        <h3 class="heading">ログアウトしました。</h3>
      </NoticeHeader>
      <NoticeBody>ご利用ありがとうございました。</NoticeBody>
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal -md" router-name="sv001">
        サービスサイトトップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import {
  removeUserSessionCookie,
  authLogout,
  getUserSessionCookie,
} from "@/utils/Auth";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "Tem024",
  components: {
    NoticeBody,
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBox,
  },
  setup() {
    setMeta({
      title: "au PAY スマートローン",
      titleTemplate: null,
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト",
    });
  },
  data() {
    return {};
  },
  mounted() {
    try {
      if (getUserSessionCookie()) {
        authLogout()
          .then(() => {})
          .catch((error) => {
            goToErrorPage(error);
          })
          .finally(() => {
            removeUserSessionCookie();
          });
      }
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
